// extracted by mini-css-extract-plugin
export var actions = "_4f-0";
export var actionsContainer = "_4f-7";
export var border = "_4f-1";
export var childFullHeight = "_4f-e";
export var collapse = "_4f-2";
export var content = "_4f-9";
export var contentChild = "_4f-d";
export var fullscreen = "_4f-b";
export var hasLeftRadius = "_4f-q";
export var headerContainer = "_4f-3";
export var headerRow = "_4f-5";
export var hidePadding = "_4f-a";
export var navCollapsedGap = "_4f-r";
export var noScrollX = "_4f-s";
export var noScrollY = "_4f-t";
export var noTopPadding = "_4f-o";
export var optOutTopPadding = "_4f-c";
export var outletContent = "_4f-k";
export var outletContentInner = "_4f-l";
export var outletLeadingPanel = "_4f-h";
export var outletLeadingPanelAttention = "_4f-i";
export var outletResizeDivider = "_4f-j";
export var outletSplit = "_4f-f";
export var outletSplitResizing = "_4f-g";
export var pageMain = "_4f-p";
export var pageOuter = "_4f-m";
export var pagePadding = "_4f-8";
export var profile = "_4f-u";
export var profileContainer = "_4f-v";
export var profileImage = "_4f-w";
export var profileMain = "_4f-x";
export var profileSubtitle = "_4f-z";
export var profileTitle = "_4f-y";
export var showLeftPadding = "_4f-n";
export var tabsPortalSlot = "_4f-6";
export var tabsWrapper = "_4f-4";
export var title = "_4f-10";